import * as React from "react";

const LoadingRow = ({ numColumns }: { numColumns: number }) => {
  const cells: React.ReactNode[] = [];
  for (let i = 0; i < numColumns; ++i) {
    cells.push(
      <td key={i}>
        <span className="bp4-skeleton">&nbsp;</span>
      </td>
    );
  }

  return <tr>{cells}</tr>;
};

export default LoadingRow;
